<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="6">
                    <p class="text-center"><img src="/images/logo.png" width="300" style="margin-bottom: 10px;" class="img-responsive" ></p>
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <p v-if="error" class="alert alert-danger">{{ error }}</p>
                                <form @submit.prevent="submitResetPassword">
                                    <p class="text-muted">Reset Password</p>
                                    <b-input-group class="mb-3 default">
                                        <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                                        <input type="text" class="form-control" placeholder="Email" v-model="email">
                                        <div v-if="hasError('email')" class="invalid-feedback d-block">{{ errs.email[0] }}</div>
                                    </b-input-group>
                                    <b-input-group class="mb-4 default">
                                        <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                                        <input :autocomplete="false" type="password" class="form-control" placeholder="New password" v-model="password">
                                        <div v-if="hasError('password')" class="invalid-feedback d-block">{{ errs.password[0] }}</div>
                                    </b-input-group>
                                    <b-input-group class="mb-4 default">
                                        <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                                        <input :autocomplete="false" type="password" class="form-control" placeholder="Confirm new password" v-model="password_confirmation">
                                    </b-input-group>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button type="submit" variant="primary" class="px-4 d-block w-100 rounded-pill">Reset</b-button>
                                        </b-col>
                                    </b-row>
                                </form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'Login',

  data() {
    return {
      email: null,
      password: null,
      password_confirmation: null,
      token: null,
      error: null,
      errs: [],
    };
  },

  created() {
    this.token = this.$route.params.token;
  },

  methods: {
    submitResetPassword(e) {
      axios
        .post('password/reset', {
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token,
        })
        .then((response) => {
          this.$router.push('/orders/new-shipment');
        })
        .catch((error) => {
          this.errs = error.response.data.errors;
        });
    },
    hasError(field) {
      return _.has(this.errs, field);
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/Auth/Reset.vue